// removed by extract-text-webpack-plugin
module.exports = {"container":"_3WM-W","formContainer":"_1-Uky","btnWrap":"_1ZBWE","nameFieldWrapper":"_31e5e","col":"gfUPW","accountPinFieldWrapper":"_2901u","qffInfoWrapper":"_15X_G"};


//////////////////
// WEBPACK FOOTER
// ./containers/stages/PersonalInfoStage/styles.scss
// module id = 705
// module chunks = 0